import React from "react";
import Header from "../components/Navbar";
import Sidebar from "../components/sidebar";
import { Outlet, useLocation } from "react-router-dom";

export default function DefaultLayout() {
  const location = useLocation();
  // Define sidebar configurations for each route
  const sidebarConfig = {
    "/faceswap": {
      title: "Faceswap",
      menuItems: [
        { name: "All Categories", value: "faceswap" },
        { name: "Photos", value: "faceswap/photos" },
        { name: "Videos", value: "faceswap/videos" },
        // { name: "Filter", value: "faceswap/filter" },
      ],
    },
    "/ai-avatar": {
      title: "AI Avatar",
      menuItems: [
        {
          name: "Ai Avatar",
          value: "ai-avatar",
        },
        { name: "Styles", value: "ai-avatar/styles" },
      ],
    },
  };

  // Determine sidebar options for the current route or provide defaults
  const currentSidebar = Object.keys(sidebarConfig).find((path) =>
    location.pathname.startsWith(path),
  );

  const { title, menuItems } = sidebarConfig[currentSidebar] || {
    title: "",
    menuItems: [],
  };

  const basePath = location.pathname.split("/")[1];
  // Hide sidebar for routes without configuration
  const showSidebar = !!menuItems.length;

  return (
    <div>
      <Header />
      <div className="flex gap-[20px] px-4 pb-[52px] pt-[40px] xl:gap-[40px] xl:px-[60px]">
        {showSidebar && (
          <Sidebar title={title} menuItems={menuItems} basePath={basePath} />
        )}
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
